<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Manage</h3>
    </div>
    <form v-on:submit="save">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Role Template</label>
              <select class="form-control form-control-sm" v-model="roleGroupID" v-on:change="loadRoles()">
                <option value="0">--Select--</option>
                <option v-for="item in roleGroups" :value="item.RoleGroupID" v-text="item.Name"></option>
              </select>
            </div>
            <br />
          </div>
        </div>
        <div class="card card-gray-dark" v-for="(m, a) in roles">
          <div class="card-header">
            <div class="card-title">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" :id="'m' + a" v-model="m.Selected" v-on:change="checkAll(m.Selected, m.Forms, true)">
                <label :for="'m' + a" class="custom-control-label" style="font-weight: 500" v-text="m.Menu"></label>
              </div>
            </div>
            <div class="card-tools">
              <button type="button" style="margin-top: -3px;" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-4" v-for="(item, i) in m.Forms">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" :id="'m' + a + i" v-model="item.Selected" v-on:change="checkAll(item.Selected, item.Roles)">
                    <label :for="'m' + a + i" class="custom-control-label" v-text="item.Form"></label>
                  </div>
                  <div>
                    <div style="margin-left: 25px;" v-for="(r, j) in item.Roles" class="custom-control custom-checkbox">
                      <input class="custom-control-input" type="checkbox" :id="'r' + a + i + j" v-model="r.Selected">
                      <label :for="'r' + a + i + j" class="custom-control-label" style="font-weight: 500" v-text="r.Name"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <input value="Save" type="submit" class="btn btn-success float-right" />
      </div>
    </form>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({

    data() {
      return {
        roleGroups: [],
        roleGroupID: 0,
        roles: []
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/RoleApi/loadRoleGroups')
          .then(function (res) {
            if (res.data.status)
              vm.roleGroups = res.data.roleGroups;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadRoles() {
        var vm = this;
        if (vm.roleGroupID && vm.roleGroupID > 0) {
          startReq();
          axios.get('/api/RoleApi/loadRolesGroupWise?roleGroupID=' + vm.roleGroupID)
            .then(function (res) {
              if (res.data.status)
                vm.roles = res.data.lst;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      checkAll(state, lst, nested) {
        lst.forEach(function (i) {
          i.Selected = state;
          if (nested) {
            i.Roles.forEach(function (j) {
              j.Selected = state;
            });
          }
        });
      },

      save(e) {
        e.preventDefault();
        if (!this.roleGroupID || this.roleGroupID < 1) {
          toastr.error("Role Template is required");
          return;
        }
        var vm = this;
        startReq();

        axios.post('/api/RoleApi/saveRoleTemplate?RoleGroupID=' + vm.roleGroupID, {
          Menus: vm.roles
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.clear();
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                //console.log(`${value}`);
                toastr.error(`${value}`);
              }
            }
          })
      },

      clear() {
        this.roleGroupID = 0;
        this.roles = [];
      }

    }
  })
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/core/roleTemplate.vue